class reviewsSlider extends HTMLElement {
  constructor() {
    super();
    const scrollers = this.querySelectorAll("[data-animated]");
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }
    function addAnimation() {
      scrollers.forEach((scroller) => {
        const scrollerInner = scroller.querySelector("[data-strip]");
        const scrollerContent = Array.from(scrollerInner.children);

        const originalItems = [...scrollerContent];

        for (let i = 0; i < 5; i++) {
          originalItems.forEach((item) => {
            const duplicatedItem = item.cloneNode(true);
            duplicatedItem.setAttribute("aria-hidden", true);
            scrollerInner.appendChild(duplicatedItem);
          });
        }
      });
    }
  }
}
customElements.define("reviews-slider", reviewsSlider);
